import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  is404: boolean;

  constructor(public route: ActivatedRoute) {
    let paramError;
    route.params.subscribe((params) => {
      paramError = params['paramError'];
    });
    if (paramError !== null && paramError !== undefined) {
      if (paramError === '403') {
        this.is404 = false;
      } else {
        this.is404 = true;
      }
    } else {
      this.is404 = true;
    }
  }

  ngOnInit() {}
}
